import React, { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { ShoppingPassErrorInterface } from '../../interfaces/ShoppingPass.interface';
import '../singleUseCard/singleUseCard.css';

const ShoppingPassError = (
  shoppingPassContent: ShoppingPassErrorInterface,
): ReactElement => {
  const { errorText } = shoppingPassContent;
  return (
    <div className="generate-shopping-pass-error-block">
      <div className="exclamation-triangle-section">
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="exclamation-triangle-icon"
        />
      </div>
      <div className="generate-shopping-pass-card-error-text">{errorText}</div>
    </div>
  );
};

export default ShoppingPassError;
